import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const EmailVerificationPromptScreen = lazyWithSuspense(
  async () => import('./EmailVerificationPromptScreen'),
  { exportKey: 'EmailVerificationPromptScreen' },
);
